module.exports = __webpack_public_path__ + "141d4a85/img/splash-icon.07a7c465.svg";